import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import golfTheme from './theme/golfTheme';
import MaintenancePage from './pages/MaintenancePage';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import CustomersPage from './pages/CustomersPage';
import PaymentPage from './pages/PaymentPage';
import GuestPaymentPage from './pages/GuestPaymentPage';
import PaymentCallbackPage from './pages/PaymentCallbackPage';
import ProtectedRoute from './components/common/ProtectedRoute';

// MAINTENANCE MODE - Set to false to disable
const MAINTENANCE_MODE = false;

const App: React.FC = () => {
  // Show maintenance page if enabled
  if (MAINTENANCE_MODE) {
    return (
      <ThemeProvider theme={golfTheme}>
        <CssBaseline />
        <MaintenancePage />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={golfTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Redirect root to login */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Login Page */}
          <Route path="/login" element={<LoginPage />} />

          {/* Admin Dashboard - Protected */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* Customers Page - Protected */}
          <Route
            path="/customers"
            element={
              <ProtectedRoute>
                <CustomersPage />
              </ProtectedRoute>
            }
          />

          {/* Payment Callback - Public (Ziraat Bank 3D Secure return URL) */}
          {/* IMPORTANT: Must be before /pay/:linkId to avoid route collision */}
          <Route path="/pay/callback" element={<PaymentCallbackPage />} />
          <Route path="/pay/callback/success" element={<PaymentCallbackPage />} />
          <Route path="/pay/callback/failed" element={<PaymentCallbackPage />} />

          {/* Payment Page - Public */}
          <Route path="/pay/:linkId" element={<PaymentPage />} />

          {/* Guest Payment - Public */}
          <Route path="/guest-payment" element={<GuestPaymentPage />} />

          {/* Catch all - redirect to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>

      {/* Toast Notifications */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </ThemeProvider>
  );
};

export default App;
